---
title: Why Estimating Projects is Hard
date: 2019-09-29T14:56:45-05:00
draft: true
---

Why estimating projects is hard

use painting analogy
- when we think of painting a house, we think of the walls
    - the large flat spots are the easiest/quickest to paint
    - the reality is it’s the corners/eaves/trim work that takes the most time
- When we estimate a project, we estimate it’s core functionality
    - the integrations/edge cases/validations are where time gets sucked up

Practical tips
